import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "deduplication",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-crm" */ "Admissions/features/CRM/components/Deduplication"
    ).then(m => m.default)
  ),
});
